import { Reducer } from 'redux'
import { IGlobalState } from '../interfaces'
import Cookies from 'universal-cookie'
import { Actions, GlobalActions } from '../actions/globalAction'
import { LboCookie } from 'shared/Constants'

const getStoredVestiging = () => {
  const cookies = new Cookies()
  const opgeslagenVestiging = cookies.get(LboCookie.cookieName)
  return opgeslagenVestiging
}

const initialState: IGlobalState = {
  vestiging: getStoredVestiging(),
  possibleGroupLinkOrderTypes: [],
  loadingOrderTypes: false,
}

export const globalReducer: Reducer<IGlobalState, GlobalActions> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case Actions.SetVestigingAction:
      return { ...state, vestiging: action.payload }
    case Actions.SetPossibleOrderTypesRequestAction:
      return {
        ...state,
        possibleGroupLinkOrderTypes: [],
        loadingOrderTypes: true,
      }
    case Actions.SetPossibleOrderTypesResponseAction:
      return {
        ...state,
        possibleGroupLinkOrderTypes: action.payload,
        loadingOrderTypes: false,
      }
    default:
      // The following line guarantees that every action in the KnownAction union has been covered by a case above
      neverReached(action as never)
  }
  return state
}

// tslint:disable-next-line:no-empty
const neverReached = (never: never) => {}
